import Keycloak from "keycloak-js";
import {useEffect, createContext, useState} from "react";
export const KeycloakContext = createContext();
let client;
const KeycloakProvider = ({children, config}) => {
	const [keycloak, setKeycloak] = useState(null);
	// console.log("[Keycloak] config", config);
	useEffect(() => {
		const initialize = async() => {
			try {
				// console.log("[Keycloak] Initialize");
				client = new Keycloak(config);
				client.onTokenExpired = async() => {
					 // console.log("[Keycloak] token expired", client.token);
					// console.log("[Keycloak] token expired");
					try {
						await client.updateToken(30);
						// console.log("[Keycloak] successfully get a new token", client.token);
						// console.log("[Keycloak] successfully get a new token");

						setKeycloak({token: client.accessToken, ...client});
					}
					catch (e) {
						console.error("[Keycloak] Failed to get a new token");
						console.error(e);
					}
				};

				const token = localStorage.getItem("kc_token");
				const refreshToken = localStorage.getItem("kc_refreshToken");
				// console.log("[Keycloak] token", token, "refreshToken", refreshToken);
				const authenticated = await client.init({onLoad: "login-required", checkLoginIframe: false, token, refreshToken});
				localStorage.setItem("kc_token", client.token);
				localStorage.setItem("kc_refreshToken", client.refreshToken);
				if (authenticated) {
					// console.log(`[Keycloak] User is ${authenticated ? "authenticated" : "not authenticated"}`);
					setKeycloak({token: client.accessToken, ...client});

				}
				else {
					// console.log("[Keycloak] User is not authenticated");
				}


			}
			catch (e) {
				// console.log("[Keycloak] error");
				console.error(e);
			}
		};
		initialize()
			.catch((e) => console.error(e));
	}, []);
	return <KeycloakContext.Provider
		value={{
			ready: keycloak !== null,
			...keycloak
		}}
	>
		{children}
	</KeycloakContext.Provider>;
};
export default KeycloakProvider;
